export enum CustomerColumn {
  Name = 'name',
  Partner = 'partner',
  Configured = 'configured',
  BetaFeaturesEnabled = 'betaFeaturesEnabled',
  HostLicenses = 'hostLicenses',
  Actions = 'actions',
}

export namespace CustomerColumn {
  export const allColumns: string[] = [
    CustomerColumn.Name,
    CustomerColumn.Partner,
    CustomerColumn.Configured,
    CustomerColumn.BetaFeaturesEnabled,
    CustomerColumn.HostLicenses,
    CustomerColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    CustomerColumn.Name,
    CustomerColumn.Partner,
    CustomerColumn.Configured,
    CustomerColumn.BetaFeaturesEnabled,
    CustomerColumn.HostLicenses,
    CustomerColumn.Actions,
  ];

  export const translateKey = (column: string): string => {
    switch (column) {
      case CustomerColumn.Name:
        return 'customers.columns.name';
      case CustomerColumn.Partner:
        return 'customers.columns.partner';
      case CustomerColumn.Configured:
        return 'customers.columns.configured';
      case CustomerColumn.BetaFeaturesEnabled:
        return 'customers.columns.betaFeaturesEnabled';
      case CustomerColumn.HostLicenses:
        return 'customers.columns.hostLicenses.label';
      case CustomerColumn.Actions:
        return 'customers.columns.actions';
      default:
        return '';
    }
  };
  export const tooltipTranslateKey = (column: string): string => {
    switch (column) {
      case CustomerColumn.HostLicenses:
        return 'customers.columns.hostLicenses.tooltip';
      default:
        return '';
    }
  };

  export const sortField = (column: string): string => {
    switch (column) {
      case CustomerColumn.Name:
        return 'companyName';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
